import { loadConfig } from '@infrastructure/config';
import './styles/base.css';

/**
 * Punto de entrada.
 *
 * La configuracion se carga ANTES de montar (DF-11). Si falta o esta
 * incompleta, la aplicacion falla de forma explicita y no arranca: el Art. IX.5
 * prohibe asumir un valor por defecto.
 *
 * **Aqui solo se importa la configuracion** (`RF-FE-161`, plan `A-5`). El resto
 * de la aplicacion llega con `import()` cuando ya se leyo, porque los textos
 * incrustan la marca de `/config.json` al evaluarse. Un import estatico mas en
 * este archivo que arrastre un `copy.ts` haria que esos textos dijeran «Nexus»
 * en cualquier marca blanca.
 *
 * El tema ya se aplico antes de este punto, en public/theme-init.js, para
 * que no haya destello (DF-14).
 */
const container = document.getElementById('root');
if (!container) throw new Error('No existe el elemento #root.');

loadConfig()
  .then(() => import('./app/arranque'))
  .then(({ arrancar }) => {
    arrancar(container);
  })
  .catch((error: unknown) => {
    // Sin configuracion no hay aplicacion. El mensaje va en el documento porque
    // React todavia no esta montado, y no expone detalle interno (Art. VI.5).
    container.innerHTML =
      '<p style="font-family:system-ui;padding:24px">' +
      'La aplicación no pudo iniciarse. Contacta con el equipo técnico.' +
      '</p>';
    console.error(error);
  });
